import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../api/axios"; // <-- You need this for the POST
import './BackupCodes.css';

const BackupCodes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // Use local state to buffer the codes for this session/view only
  const [localCodes, setLocalCodes] = useState(() => location.state?.backupCodes || []);

  // On first mount: clear navigation state (from browser history)
  useEffect(() => {
    if (location.state?.backupCodes) {
      // Don't clear codes from local state, just from navigation state
      navigate("/admin/user/backup-codes", { replace: true, state: {} });
    }
    // eslint-disable-next-line
  }, [location.state, navigate]);

  // After codes have rendered, immediately mark as shown (backend)
  useEffect(() => {
    if (localCodes.length > 0) {
      const csrfToken = document.cookie
        .split("; ")
        .find(row => row.startsWith("csrfToken="))
        ?.split("=")[1];

      if (csrfToken) {
        axios.post(
          "/api/2fa/mark-backup-codes-shown",
          {},
          { withCredentials: true, headers: { "x-csrf-token": csrfToken } }
        ).catch(() => {
          // Optionally: handle/log errors (but don't block display)
        });
      }
    }
  }, [localCodes]);

  const handleGoBack = () => navigate("/admin/user/profile");

  return (
    <div className="backup-codes-container">
      <h2>Backup Codes</h2>
      {localCodes.length > 0 ? (
        <>
          <p>Save these codes somewhere safe. Each code can be used only once.</p>
          <ul aria-live="polite">
            {localCodes.map((code, idx) => (
              <li key={idx}><strong>{code}</strong></li>
            ))}
          </ul>
          <button onClick={handleGoBack} aria-describedby="backup-instruction">
            I Have Saved My Codes
          </button>
          <p id="backup-instruction" className="sr-only">
            Clicking this button confirms you have saved your backup codes.
          </p>
        </>
      ) : (
        <p className="error" role="alert" aria-live="polite">
          Backup codes are not available. Generate new ones if needed.
        </p>
      )}
    </div>
  );
};

export default BackupCodes;
